<template>
  <div class="details-view order-detail">
    <template>
      <div class="main-content">
        <div v-show="isEdit" class="app-main-inner-row" style="padding-left: 0px;">
          <div class="triggers">
            <el-button type="primary" @click="doSave">{{ $t('SeaExport.Save') }}</el-button>
            <el-button @click="cancel">{{ $t('SeaExport.Cancel') }}</el-button>
            <el-button v-if="false" type="warning" @click="preQuotation">{{ $t('FbaChannel.previewQuotation') }}</el-button>
          </div>
        </div>
        <div v-show="!isEdit" class="app-main-inner-row" style="padding-left: 0px;justify-content: space-between;">
          <div class="triggers">
            <el-button type="success" @click="toBackList">{{ $t('SeaExport.Return') }}</el-button>
            <el-button v-if="$checkPermission(['button_FBAQuotation_editQuotation'])" type="primary" :disabled="!form.uuid" @click="toEdit">{{ $t('SeaExport.Edit') }}</el-button>
          </div>
        </div>
        <div class="section quotation-detail" style="margin-top: 5px; width:100%; height: 95%; overflow: auto">
          <el-form
            ref="form"
            label-width="110px"
            label-position="left"
            :disabled="!isEdit"
            :show-message="false"
          >
            <el-collapse :value="collapse" @change="handleChange">
              <el-collapse-item :title="$t('SeaExport.BasicInfo')" :name="1">
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item v-if="!isAdd">
                      <span slot="label" class="blue">{{ $t('FbaChannel.channelName') }}</span>
                      <cargo-advance-select
                        no="serviceChannel"
                        disabled
                        :select-type="selectTypeNames.basic_data_FbaChannel"
                        filterable
                        :clearable="true"
                        :default-value="form.serviceChannel"
                        @parentCallBack="p=>{form.serviceChannel=p.value}"
                      />
                    </el-form-item>
                    <el-form-item v-if="isAdd">
                      <span slot="label" class="blue">{{ $t('FbaChannel.channelName') }}</span>
                      <el-select v-model="form.serviceChannel" filterable @change="changeChannelName">
                        <el-option
                          v-for="(item,index) in channel4QuotationSelect"
                          :key="index"
                          :label="item.channelName"
                          :value="item.channelName"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item>
                      <span slot="label" class="blue">{{ $t('FbaChannel.quotationValidityPeriod') }}</span>
                      <el-date-picker v-model="beginDate" :disabled="form.active" :clearable="false" :picker-options="pickerOptions" style="width:130px;" type="date" value-format="yyyy-MM-dd" @change="changeDate(false)" />&nbsp;{{ $t('CargoMsg.Cargo_To') }}
                      <el-date-picker v-model="endDate" :disabled="form.active" :clearable="false" :picker-options="pickerOptions" style="width:130px;" type="date" value-format="yyyy-MM-dd" @change="changeDate(true)" />
                      <el-checkbox v-model="form.active" style="padding-left: 2px;" @change="changeActive">{{ $t('FbaChannel.longTerm') }}</el-checkbox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label-width="0" class="auto-width">
                      <span class="el-form-item__label">{{ $t('FbaChannel.quotationLabel') }}</span>
                      <el-popover
                        placement="bottom"
                        width="450"
                        trigger="hover"
                      >
                        <div class="pop-content">{{ '标签用于客户查看当前方案时，向客户展示方案的特点，' }}</div>
                        <div class="pop-content">{{ '包括时效保证、货损赔付保障、价格优势等。' }}</div>
                        <svg-icon slot="reference" icon-class="question" style="font-size: 14px;margin-top: -3px;" />
                      </el-popover>
                      <span v-for="(item,index) in form.labelList" :key="index" style="margin-left: 5px;" @click="editTag(item)">
                        <el-tag :style="{backgroundColor: item.backgroundColor,color: item.textColor }" closable size="small" @close="handleTagClose(item)">{{ item.labelName }}</el-tag>
                      </span>
                      <img src="@/assets/add.png" :title="'添加标签'" height="16" width="16" style="vertical-align: sub;margin-left:8px;cursor:pointer" @click="onAddLabel()">
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('FbaChannel.chargingMethod')">
                      <cargo-advance-select
                        no="chargingMethod"
                        :select-type="selectTypeNames.local_cache_FbaJobConstants$CHARGING_METHODS"
                        filterable
                        :disabled="true"
                        :clearable="true"
                        :default-value="form.chargingMethod + ''"
                        @parentCallBack="p=>{form.chargingMethod=p.value}"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('FbaChannel.shippingType')">
                      <cargo-advance-select
                        no="shippingType"
                        :select-type="selectTypeNames.local_cache_FbaJobConstants$SHIPPING_TYPES"
                        filterable
                        :disabled="true"
                        :clearable="true"
                        :default-value="form.shippingType"
                        @parentCallBack="p=>{form.shippingType=p.value}"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('FbaChannel.destinationDistribution')">
                      <cargo-advance-select
                        no="destinationDistribution"
                        :select-type="selectTypeNames.local_cache_FbaJobConstants$ORDER_DESTINATION_DISTRIBUTION_TYPES"
                        filterable
                        :disabled="true"
                        :clearable="true"
                        :default-value="form.destinationDistribution + ''"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('FbaChannel.singleBoxLowestBillableWeight')">
                      <el-input-number :disabled="true" :value="form.singleBoxLowestBillableWeight ? form.singleBoxLowestBillableWeight : 0" :no="'singleBoxLowestBillableWeight'" controls-position="right" :max="999.99" :min="0" :precision="2" /> {{ 'KG' }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('FbaChannel.multipleBoxesCalculationRules')">
                      <cargo-advance-select
                        no="multipleBoxesCalculationRules"
                        :select-type="selectTypeNames.local_cache_FbaJobConstants$MULTIPLE_BOXES_CALCULATION_RULES"
                        filterable
                        :disabled="true"
                        :clearable="true"
                        :default-value="form.multipleBoxesCalculationRules"
                        @parentCallBack="p=>{form.multipleBoxesCalculationRules=p.value}"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('FbaChannel.settlementWeightRoundingRules')">
                      <cargo-advance-select
                        no="settlementWeightRoundingRules"
                        :select-type="selectTypeNames.local_cache_FbaJobConstants$SETTLEMENT_WEIGHT_ROUNDING_RULES"
                        filterable
                        :disabled="true"
                        :clearable="true"
                        :default-value="form.settlementWeightRoundingRules"
                        @parentCallBack="p=>{form.settlementWeightRoundingRules=p.value}"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('FbaChannel.bubbleCountingRatio')">
                      <el-input-number :value="form.bubbleCountingRatio ? form.bubbleCountingRatio : 1" :no="'bubbleCountingRatio'" :disabled="true" controls-position="right" :max="9999" :min="1" :precision="0" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('FbaChannel.BubbleSplittingRatio')">
                      <el-input-number :value="form.bubbleSplittingRatio ? form.bubbleSplittingRatio : 0" :no="'bubbleSplittingRatio'" :disabled="true" controls-position="right" :max="100" :min="0" :precision="0" /> {{ '%' }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('FbaChannel.acceptableGoods')">
                      <el-checkbox-group v-model="acceptableGoods" :disabled="true">
                        <el-checkbox
                          v-for="item in fbaCargoType"
                          :key="item.code"
                          :label="item.code"
                        >
                          {{ item.chineseName }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="24">
                    <el-form-item :label="$t('SeaExport.Considerations')" />
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="24">
                    <el-form-item label-width="0">
                      <el-input
                        v-model="form.note"
                        type="textarea"
                        placeholder="请输入下单的注意事项，如货物要求、包装要求、特殊要求、温馨提示、赔付承诺、免责说明等"
                        :rows="10"
                        style="width: 100%;"
                        maxlength="10000"
                        show-word-limit
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-show="!showNextOne && !form.uuid" :gutter="10" style="padding-top: 8px;">
                  <el-col :span="24">
                    <el-button type="primary" @click="onNextStepOne">{{ $t('Pricing.Next') }}</el-button>
                  </el-col>
                </el-row>
              </el-collapse-item>
              <span v-if="showNextOne">
                <el-collapse-item title="分区梯度" :name="2">
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <span class="title">{{ '分区设置' }}</span>
                      <el-popover
                        placement="bottom"
                        width="450"
                        trigger="hover"
                      >
                        <div class="pop-content">{{ 'tips：什么是分区？' }}</div>
                        <div class="pop-content">{{ '如果几个目的地的运费价格是一样的，则可以组成一个分区；运费价格不相同的，则需要在不同的分区中。' }}</div>
                        <svg-icon slot="reference" icon-class="question" style="font-size: 14px;margin-top: -3px;" />
                      </el-popover>
                    </el-col>
                    <el-col :span="12">
                      <span class="title">{{ '阶梯设置' }}</span>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="24">
                      <el-form-item label-width="0" class="auto-width">
                        <span class="blue">{{ '计费区间类型' }}</span>
                        <el-popover
                          placement="bottom"
                          width="450"
                          trigger="hover"
                        >
                          <div class="pop-content">{{ this.$t('FbaQuotation.chargePartTypeTipsL1') }}</div>
                          <div class="pop-content">{{ this.$t('FbaQuotation.chargePartTypeTipsL2') }}</div>
                          <div class="pop-content">{{ this.$t('FbaQuotation.chargePartTypeTipsL3') }}</div>
                          <svg-icon slot="reference" icon-class="question" style="font-size: 14px;margin-top: -3px;" />
                        </el-popover>

                        <el-radio-group v-model="form.chargePartType" :disabled="!!form.serviceChannel">
                          <el-radio :label="0">{{ this.$t('FbaQuotation.chargePartTypeKG') }}</el-radio>
                          <el-radio :label="1">{{ this.$t('FbaQuotation.chargePartTypeCBM') }}</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" style="padding-bottom: 8px;">
                    <el-col :span="12">
                      <el-button type="primary" @click="addPartitionSetting">{{ '添加' }}</el-button>
                      <el-button type="danger" @click="deletePartitionSetting">{{ '删除' }}</el-button>
                      <span style="padding-left: 10px;">{{ '注意：分区最多添加50个，最少留1个' }}</span>
                    </el-col>
                    <el-col :span="12">
                      <el-button type="primary" @click="addSetupSetting">{{ '添加' }}</el-button>
                      <el-button type="danger" @click="deleteSetupSetting">{{ '删除' }}</el-button>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <cargo-ag-grid
                        config-module="1001102"
                        :grid-options="fqsz.gridOptions"
                        :column-defs="fqszColumns"
                        :row-data="fqsz.rowData || []"
                        style="height: 200px;"
                        :show-side-bar="false"
                        @gridReady="params=>{fqsz.gridApi=params.api}"
                      />
                    </el-col>
                    <el-col :span="12">
                      <cargo-ag-grid
                        config-module="1001103"
                        :grid-options="jtsz.gridOptions"
                        :column-defs="jtszColumns"
                        :row-data="jtsz.rowData || []"
                        style="height: 200px;"
                        :show-side-bar="false"
                        @gridReady="params=>{jtsz.gridApi=params.api}"
                      />
                    </el-col>
                  </el-row>
                  <el-row v-if="showNextOne && !showNextTwo && !form.uuid" :gutter="10" style="padding-top: 8px;">
                    <el-col :span="24">
                      <el-button type="primary" @click="onNextStepTwo">{{ $t('Pricing.Next') }}</el-button>
                    </el-col>
                  </el-row>
                </el-collapse-item>
              </span>
              <span v-if="showNextTwo">
                <el-collapse-item
                  title="客户价"
                  :name="3"
                >
                  <el-row :gutter="10">
                    <el-col :span="20">
                      <el-button type="primary" @click="addCustomerPrice">{{ '添加' }}</el-button>
                      <el-button type="danger" @click="deleteCustomerPrice">{{ '删除' }}</el-button>
                      <el-popover
                        style="padding-left: 10px;"
                        placement="bottom"
                        width="450"
                        trigger="hover"
                      >
                        <div class="pop-content">{{ '公开报价对应的就是无需客户登录时，查询的那个价格。那边取的就是这个值。' }}</div>
                        <div class="pop-content">{{ '如果一个渠道有个公开报价，同时也有对特定客户的客户报价。当特定客户查询时，显示的就是客户报价。非特定客户查询的就是公开报价。' }}</div>
                        <svg-icon slot="reference" icon-class="question" style="font-size: 14px;margin-top: -3px;" />
                      </el-popover>
                      <span>{{ '注意：客户价不能重复添加' }}</span>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item>
                        <span slot="label" class="blue">{{ $t('FinanceManage.charge_currency') }}</span>
                        <cargo-advance-select
                          filterable
                          :clearable="false"
                          :select-type="selectTypeNames.basic_data_Currency"
                          :default-value="form.currency"
                          :disabled="!isEdit"
                          @parentCallBack="item=>form.currency=item.value"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="6">
                      <span class="title">{{ '运价级别' }}</span>
                    </el-col>
                    <el-col :span="6">
                      <span class="title">{{ '分区信息' }}</span>
                    </el-col>
                    <el-col :span="12">
                      <span class="title">{{ '阶梯信息' }}</span>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <!-- 报价对象-->
                    <el-col :span="6">
                      <cargo-ag-grid
                        config-module="1001104"
                        :grid-options="khjBjdx.gridOptions"
                        :column-defs="khjBjdxColumns"
                        :row-data="khjBjdx.rowData || []"
                        style="height: 200px"
                        :show-side-bar="false"
                        @gridReady="params=>{khjBjdx.gridApi=params.api}"
                      />
                    </el-col>
                    <!-- 报价对象 对应 多个 分区-->
                    <el-col :span="6">
                      <cargo-ag-grid
                        config-module="5"
                        :grid-options="khjFq.gridOptions"
                        :column-defs="khjFqColumns"
                        :row-data="khjBjdxSelected ? khjBjdxSelected.fqRowData : []"
                        style="height: 200px"
                        :show-side-bar="false"
                        @gridReady="params=>{khjFq.gridApi=params.api}"
                      />
                    </el-col>
                    <!-- 分区 对应 多个 阶梯设置-->
                    <el-col :span="12">
                      <cargo-ag-grid
                        config-module="6"
                        :grid-options="khjJt.gridOptions"
                        :column-defs="khjJtColumns"
                        :row-data="khjBjdxFqSelected ? khjBjdxFqSelected.tdRowData : []"
                        style="height: 200px"
                        :show-side-bar="false"
                        @gridReady="params=>{khjJt.gridApi=params.api}"
                      />
                    </el-col>
                  </el-row>
                  <el-row v-if="showNextTwo && !showNextThree && !form.uuid" :gutter="10" style="padding-top: 8px;">
                    <el-col :span="24">
                      <el-button type="primary" @click="onNextStepThree">{{ $t('Pricing.Next') }}</el-button>
                    </el-col>
                  </el-row>
                </el-collapse-item>
              </span>
              <span v-if="showNextThree">
                <el-collapse-item
                  title="附加费"
                  :name="4"
                >
                  <el-row :gutter="10">
                    <el-col :span="24">
                      <el-button type="primary" @click="addCharge">{{ '添加' }}</el-button>
                      <el-button type="primary" @click="editCharge">{{ '编辑' }}</el-button>
                      <el-button type="danger" @click="deleteCharge">{{ '删除' }}</el-button>
                      <span style="padding-left: 8px;">注意：双击查看附加费详情</span>
                    </el-col>
                  </el-row>
                  <!-- 附加费列表-->
                  <el-row :gutter="10">
                    <el-col :span="24" style="margin-top: 10px;">
                      <cargo-ag-grid
                        config-module="1001107"
                        :grid-options="fjf.gridOptions"
                        :column-defs="fjfColumns"
                        :row-data="fjf.rowData || []"
                        style="height: 200px"
                        :show-side-bar="false"
                        @gridReady="params=>{fjf.gridApi=params.api}"
                      />
                    </el-col>
                  </el-row>
                </el-collapse-item>
              </span>
            </el-collapse>
          </el-form>
        </div>
      </div>
    </template>

    <!-- 添加客户价 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="addCustomerPriceDialog.visible"
      :title="'运价级别对应所属客户'"
      width="1000px"
      :close-on-click-modal="false"
    >
      <div style="flex-grow:1;display:flex;flex-direction:column;text-align: center;">
        <el-form label-position="left" label-width="90px">
          <el-row :gutter="10">
            <el-col :span="7">
              <el-form-item :label="$t('SeaExport.CustomerName')">
                <cargo-company-select
                  :method-params="{customer:true, active:true, fba:true}"
                  :check-credit="true"
                  :static-options="customerCmpList"
                  :default-value="addCustomerPriceDialog.accountId||''"
                  :data-filter-function="customerIdFilter"
                  @change="p=>{addCustomerPriceDialog.accountId = p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label-width="0">
                <el-button type="primary" @click="searchCustomerPriceHandler">{{ $t('common.btn.query') }}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <cargo-ag-grid
        config-module="1001108"
        :grid-options="addCustomerPriceDialog.gridOptions"
        :column-defs="addCustomerPriceDialog.columnDefs"
        :row-data="addCustomerPriceDialog.rowData"
        :grid-params.sync="addCustomerPriceDialog.gridParams"
        :check-main-record="false"
        :deselect-main-record="false"
        style="margin-top: 10px;height: 400px;"
        @gridReady="params=>addCustomerPriceDialog.gridApi=params.api"
      />
      <div slot="footer">
        <el-button @click="addCustomerPriceDialog.visible=false">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
      </div>
    </el-dialog>

    <!-- 设置目的地 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="podDialog.visible"
      :title="'目的地维护'"
      width="1000px"
      :close-on-click-modal="false"
    >
      <div class="grid-view">
        <div class="main-content">
          <search-item
            config-module="10020"
            :custom-search-items="customSearchItems"
            :reset="true"
            :expand-adv="true"
            :custom-sim-query-placeholder="$t('common.tips.overseaWarehouseFuzzySearch')"
            @click-more="value=>isAdvancedQuery=value"
            @advSearchItemCallBack="fetchData"
            @simSearchItemCallBack="fetchDataByKeyWord"
          />
          <cargo-ag-grid
            config-module="1001109"
            :grid-options="podDialog.gridOptions"
            :column-defs="podDialog.columnDefs"
            :row-data="podDialog.rowData"
            :grid-params.sync="podDialog.gridParams"
            :check-main-record="false"
            :deselect-main-record="false"
            style="margin-top: 10px;height: 400px;"
            @gridReady="params=>podDialog.gridApi=params.api"
          />
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="confirmPod">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="podDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 附加费维护 -->
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="chargeDialog.visible"
      :title="'附加费维护'"
      :show-close="false"
      width="1000px"
    >
      <div class="main-content" style="flex-grow:1;display:flex;flex-direction:column;width:100%;height: 520px; overflow-y: auto;">
        <el-form label-position="left" label-width="90px" :inline="true" :disabled="chargeDialog.action === 'look'">
          <el-row :gutter="10">
            <el-col :span="24">
              <span class="title">{{ '基础信息' }}</span>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item>
                <span slot="label" class="blue">{{ '附加费名称' }}</span>
                <cargo-advance-select
                  :need-copy="false"
                  filterable
                  :select-type="selectTypeNames.basic_data_ChargeItem"
                  :static-options="chargeItemList"
                  :default-value="chargeDialog.charge.chargeItemId || ''"
                  options-width="100px"
                  style="width: 180px;"
                  @parentCallBack="p=>{chargeDialog.charge.chargeItemId=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item>
                <span slot="label" class="blue">{{ '附加费类型' }}</span>
                <cargo-advance-select
                  :need-copy="false"
                  :cache="false"
                  :clearable="false"
                  :tag-name="isZh ? 'chineseName' : 'englishName'"
                  tag-value="code"
                  style="width: 180px;"
                  :static-options="FbaJobConstants.SURCHARGE_TYPES"
                  :default-value="chargeDialog.charge.chargeType"
                  @parentCallBack="p=>{chargeDialog.charge.chargeType=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item>
                <span slot="label" class="blue">{{ '币别' }}</span>
                <cargo-advance-select
                  :need-copy="false"
                  filterable
                  :select-type="selectTypeNames.basic_data_Currency"
                  :default-value="chargeDialog.charge.currency || ''"
                  options-width="100px"
                  style="width: 180px;"
                  @parentCallBack="p=>{chargeDialog.charge.currency=p.value}"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" style="padding-top: 8px;">
            <el-col :span="24">
              <span class="title">{{ '加收场景' }}</span>
            </el-col>
          </el-row>
          <el-row :gutter="10" style="padding-top: 8px;padding-bottom: 8px;">
            <el-col :span="24">
              <el-button type="primary" @click="addChargeScene">增加加收场景</el-button>
              <span style="padding-left: 10px;">{{ '注意：最多支持10个场景，如果第一个场景的加收条件达成，将按第一个场景的计费方式收费，不再执行下一个场景' }}</span>
            </el-col>
          </el-row>

          <div v-for="(item,index) in chargeDialog.charge.chargeSceneList" :key="item.uuid + index" class="section" style="padding-left: 20px;">
            <el-row :gutter="10">
              <el-col :span="20">
                <el-form-item :label="'加收条件'" />
              </el-col>
              <el-col :span="4">
                <el-button type="danger" @click="deleteChargeScene(item)">删除</el-button>
              </el-col>
            </el-row>
            <div style="padding-left: 20px; padding-top: 8px;">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label-width="0">
                    <span>{{ ' ' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label-width="0">
                    <cargo-advance-select
                      :need-copy="false"
                      :placeholder="'比较值类型'"
                      :cache="false"
                      clearable
                      :tag-name="isZh ? 'chineseName' : 'englishName'"
                      tag-value="code"
                      style="width: 180px;"
                      :static-options="FbaJobConstants.COMPARISON_TYPES"
                      :default-value="item.type1 || ''"
                      @parentCallBack="p=>{item.type1=p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label-width="0">
                    <cargo-advance-select
                      :need-copy="false"
                      :placeholder="'比较规则'"
                      :cache="false"
                      clearable
                      :tag-name="isZh ? 'chineseName' : 'englishName'"
                      tag-value="code"
                      style="width: 180px;"
                      :static-options="FbaJobConstants.COMPARISON_RULES"
                      :default-value="item.rule1 || ''"
                      @parentCallBack="p=>{item.rule1=p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label-width="0">
                    <el-input-number v-model="item.value1" :precision="4" :controls="false" style="width: 100%;" :placeholder="'值'" :max="999999.9999" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label-width="0">
                    <cargo-advance-select
                      :need-copy="false"
                      :placeholder="' '"
                      :cache="false"
                      clearable
                      :tag-name="isZh ? 'chineseName' : 'englishName'"
                      tag-value="code"
                      style="width: 180px;"
                      :static-options="FbaJobConstants.AND_OR"
                      :default-value="item.relationShip2 || ''"
                      @parentCallBack="p=>{item.relationShip2=p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label-width="0">
                    <cargo-advance-select
                      :need-copy="false"
                      :placeholder="'比较值类型'"
                      :cache="false"
                      clearable
                      :tag-name="isZh ? 'chineseName' : 'englishName'"
                      tag-value="code"
                      style="width: 180px;"
                      :static-options="FbaJobConstants.COMPARISON_TYPES"
                      :default-value="item.type2 || ''"
                      @parentCallBack="p=>{item.type2=p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label-width="0">
                    <cargo-advance-select
                      :need-copy="false"
                      :placeholder="'比较规则'"
                      :cache="false"
                      clearable
                      :tag-name="isZh ? 'chineseName' : 'englishName'"
                      tag-value="code"
                      style="width: 180px;"
                      :static-options="FbaJobConstants.COMPARISON_RULES"
                      :default-value="item.rule2 || ''"
                      @parentCallBack="p=>{item.rule2=p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label-width="0">
                    <el-input-number v-model="item.value2" :precision="4" :controls="false" style="width: 100%;" :placeholder="'值'" :max="999999.9999" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label-width="0">
                    <cargo-advance-select
                      :need-copy="false"
                      :placeholder="' '"
                      :cache="false"
                      clearable
                      :tag-name="isZh ? 'chineseName' : 'englishName'"
                      tag-value="code"
                      style="width: 180px;"
                      :static-options="FbaJobConstants.AND_OR"
                      :default-value="item.relationShip3 || ''"
                      @parentCallBack="p=>{item.relationShip3=p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label-width="0">
                    <cargo-advance-select
                      :need-copy="false"
                      :placeholder="'比较值类型'"
                      :cache="false"
                      clearable
                      :tag-name="isZh ? 'chineseName' : 'englishName'"
                      tag-value="code"
                      style="width: 180px;"
                      :static-options="FbaJobConstants.COMPARISON_TYPES"
                      :default-value="item.type3 || ''"
                      @parentCallBack="p=>{item.type3=p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label-width="0">
                    <cargo-advance-select
                      :need-copy="false"
                      :placeholder="'比较规则'"
                      :cache="false"
                      clearable
                      :tag-name="isZh ? 'chineseName' : 'englishName'"
                      tag-value="code"
                      style="width: 180px;"
                      :static-options="FbaJobConstants.COMPARISON_RULES"
                      :default-value="item.rule3 || ''"
                      @parentCallBack="p=>{item.rule3=p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label-width="0">
                    <el-input-number v-model="item.value3" :precision="4" :controls="false" style="width: 100%;" :placeholder="'值'" :max="999999.9999" />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item :label="'计算方式'">
                  <el-radio-group v-model="item.calcMethod">
                    <el-radio :label="false">{{ '固定费用' }}</el-radio>
                    <el-radio :label="true">{{ '计算公式' }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <div style="padding-left: 20px; padding-top: 8px;">
              <el-row v-if="!item.calcMethod" :gutter="10">
                <el-col :span="8">
                  <el-form-item label-width="">
                    <el-input-number v-model="item.fixedExpenses" :precision="2" :controls="false" style="width: 100%;" :max="999999.99" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="item.calcMethod" :gutter="10">
                <el-col :span="24">
                  <div style="display: flex;flex: 1; padding-bottom: 8px;">
                    <el-select
                      v-model="item.param1"
                      :allow-create="true"
                      :placeholder="'请输入数值或者选择参数'"
                      style="width: 200px;padding-right: 8px;"
                      filterable
                      :clearable="true"
                      @change="p=>{chargeSceneParamLimit(item, p, 'param1')}"
                    >
                      <el-option
                        v-for="(item,index) in FbaJobConstants.COMPARISON_TYPES"
                        :key="index"
                        :label="isZh ? item.chineseName : item.englishName"
                        :value="item.code"
                      />
                    </el-select>
                    <cargo-advance-select
                      :need-copy="false"
                      :allow-create="true"
                      filterable
                      :placeholder="' '"
                      :cache="false"
                      clearable
                      :tag-name="isZh ? 'chineseName' : 'englishName'"
                      tag-value="code"
                      style="width: 100px;padding-right: 8px;"
                      :static-options="FbaJobConstants.CALC_MODES"
                      :default-value="item.mode2 || ''"
                      @parentCallBack="p=>{item.mode2=p.value}"
                    />
                    <el-select
                      v-model="item.param2"
                      :allow-create="true"
                      :placeholder="'请输入数值或者选择参数'"
                      style="width: 200px;padding-right: 8px;"
                      filterable
                      :clearable="true"
                      @change="p=>{chargeSceneParamLimit(item, p, 'param2')}"
                    >
                      <el-option
                        v-for="(item,index) in FbaJobConstants.COMPARISON_TYPES"
                        :key="index"
                        :label="isZh ? item.chineseName : item.englishName"
                        :value="item.code"
                      />
                    </el-select>
                    <cargo-advance-select
                      :need-copy="false"
                      :placeholder="' '"
                      :cache="false"
                      clearable
                      :tag-name="isZh ? 'chineseName' : 'englishName'"
                      tag-value="code"
                      style="width: 100px;padding-right: 8px;"
                      :static-options="FbaJobConstants.CALC_MODES"
                      :default-value="item.mode3 || ''"
                      @parentCallBack="p=>{item.mode3=p.value}"
                    />
                    <el-select
                      v-model="item.param3"
                      :allow-create="true"
                      :placeholder="'请输入数值或者选择参数'"
                      style="width: 200px;padding-right: 8px;"
                      filterable
                      :clearable="true"
                      @change="p=>{chargeSceneParamLimit(item, p, 'param3')}"
                    >
                      <el-option
                        v-for="(item,index) in FbaJobConstants.COMPARISON_TYPES"
                        :key="index"
                        :label="isZh ? item.chineseName : item.englishName"
                        :value="item.code"
                      />
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <el-row :gutter="10" style="padding-top: 16px; flex: 1;">
            <el-col :span="24">
              <span class="title">{{ '费用描述' }}</span>
            </el-col>
            <el-col :span="24">
              <el-form-item label-width="0">
                <el-input
                  v-model="chargeDialog.charge.remark"
                  type="textarea"
                  :rows="5"
                  style="width: 930px;"
                  maxlength="200"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" style="text-align: center;">
        <el-button :disabled="chargeDialog.action === 'look'" type="primary" @click="confirmCharge">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="chargeDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 标签维护 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="label.visible"
      :title="'标签维护'"
      width="340px"
      :close-on-click-modal="false"
    >
      <el-form label-width="85px" label-position="right" :disabled="!isEdit">
        <el-form-item>
          <span slot="label" class="blue">{{ '标签名称' }}</span>
          <el-input v-model="label.quotationLabel.labelName" :maxlength="10" style="width: 220px;" no="labelName" />
        </el-form-item>
        <el-form-item class="quotationLabel">
          <span slot="label" class="blue">{{ '背景颜色' }}</span>
          <el-color-picker v-model="label.quotationLabel.backgroundColor" no="backgroundColor" style="width: 220px;" />
        </el-form-item>
        <el-form-item class="quotationLabel">
          <span slot="label" class="blue">{{ '文字颜色' }}</span>
          <el-color-picker v-model="label.quotationLabel.textColor" no="textColor" style="width: 220px;" />
        </el-form-item>
        <el-form-item :label="'标签预览'">
          <el-tag v-if="label.quotationLabel.labelName" :style="{backgroundColor: label.quotationLabel.backgroundColor,color: label.quotationLabel.textColor }">{{ label.quotationLabel.labelName }}</el-tag>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" :disabled="!isEdit" @click="toLabel">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button @click="label.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import URL from '@/api/urlTranslator'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import SpecialCharacterTip from '@/components/Cargo/Common/specialCharacterTip'
import CargoInput from '@/components/Cargo/Common/cargoInput'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridColumnEditGroup from '@/components/Cargo/Common/CargoAgGridColumnEditGroup'
import { FbaQuotation } from '@/class/model/price/FbaQuotation'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import moment from 'moment'
import { getCacheListByKey, getSpecificBasicDataFromCache } from '@/utils/basicDataCache'
import { FbaPartitionSetting } from '@/class/model/price/FbaPartitionSetting'
import { FbaSetupSetting } from '@/class/model/price/FbaSetupSetting'
import { FbaCharge } from '@/class/model/price/FbaCharge'
import { FbaChargeScene } from '@/class/model/price/FbaChargeScene'
import { FbaCustomerPrice } from '@/class/model/price/FbaCustomerPrice'
import { FbaQuotationLabel } from '@/class/model/price/FbaQuotationLabel'
import UIDUtil from '@/utils/uidUtil'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridAdvanceMultipleSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import OperationRender from '@/components/OperationRender'
import CargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { save, searchCustomerPrice } from '@/api/price/fbaQuotation'
import { basicCacheKeys } from '@/utils/cacheConfig'
import lodash from 'lodash'
import StrUtils from '@/utils/StrUtils'
import { getQuotationAvailableChannels } from '@/api/Fba/fbaChannel'
import { getUserInfo } from '@/utils/auth'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { getLocationList } from '@/api/location'
import { advanceQuery, getOverseaWarehouseList } from '@/api/basicData/overseaWarehouse'
import { getFbaCustomerByRole } from '@/api/booking/job'
import { ensureExecuteSuccess } from '@/utils/commonUtil'

export default {
  name: 'QuotationDetail',
  components: { CargoCompanySelect, CargoAdvanceSelect, CargoInput, SpecialCharacterTip, searchItem },
  data() {
    return {
      FbaJobConstants,
      customSearchItems: [],
      pickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledDate
      },
      isAdvancedQuery: false, // 是否为高级查询
      customerCmpList: null,
      chargeItemList: null,
      operationType: 1,
      showNextOne: false, // 显示下一步的按钮
      showNextTwo: false, // 显示下一步的按钮
      showNextThree: false, // 显示下一步的按钮
      channel4QuotationSelect: [], // 新增报价可选渠道
      URL,
      collapse: [1, 2, 3, 4],
      selectTypeNames: TYPE_NAMES,
      acceptableGoods: [], // 可接货物
      fbaCargoType: [], // fba货物
      fqsz: { // 分区梯度-分区设置
        gridApi: null,
        rowData: [],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          singleClickEdit: true,
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridSelectEditor,
            CargoAgGridAdvanceMultipleSelectEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridColumnEditGroup
          }
        }
      },
      jtsz: { // 分区梯度-阶梯设置
        gridApi: null,
        rowData: [],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          singleClickEdit: true,
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridSelectEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridColumnEditGroup
          }
        }
      },
      khjBjdx: { // 客户价-报价对象
        gridApi: null,
        rowData: [],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          singleClickEdit: true,
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridSelectEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridColumnEditGroup
          },
          onRowSelected: this.getKhjBjdxSelectedRow,
          onRowClicked: this.getKhjBjdxSelectedRow
        }
      },
      khjFq: { // 客户价-分区
        gridApi: null,
        rowData: [],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          singleClickEdit: true,
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridSelectEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridColumnEditGroup
          },
          onRowSelected: this.getKhjBjdxFqSelectedRow,
          onRowClicked: this.getKhjBjdxFqSelectedRow
        }
      },
      khjJt: { // 客户价-阶梯设置
        gridApi: null,
        rowData: [],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          singleClickEdit: true,
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridSelectEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridColumnEditGroup
          }
        }
      },
      fjf: { // 附加费
        gridApi: null,
        rowData: [],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          singleClickEdit: true,
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridSelectEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridColumnEditGroup
          },
          onRowSelected: this.getFjfSelectedRow,
          onRowClicked: this.getFjfSelectedRow,
          onRowDoubleClicked: this.onFjfRowDoubleClicked
        }
      },
      deleteLabelUuids: [], // 删除标签
      deletePartitionSettingUuids: [], // 删除分区设置
      deleteSetupSettingUuids: [], // 删除阶梯设置
      deleteChargeUuids: [], // 删除附加费
      deleteChargeSceneUuids: [], // 删除附加费场景
      deleteCustomerPriceUuids: [], // 删除客户价
      addCustomerPriceDialog: { // 查看运价级别对应的客户
        visible: false,
        priceLevel: '', // 运价级别
        accountId: 0,
        gridApi: null,
        gridParams: {},
        gridOptions: {},
        columnDefs: [
          { headerName: '运价级别', field: 'AUTHORIZATION_VALUE', width: 180,
            valueFormatter: (params) => {
              return ColumnUtils.QuotationObjectLabelFunc(Number(params.value))
            } },
          { headerName: '中文名', field: 'CHINESE_NAME', width: 180 },
          { headerName: '英文名', field: 'ENGLISH_NAME', width: 180 },
          { headerName: '客户代码', field: 'CN_SHORT_NAME', width: 180 },
          {
            headerName: '客户级别', field: 'CUSTOMER_TYPE_ID', width: 180,
            valueFormatter: (params) => {
              return ColumnUtils.companyCustomerTypeLabelFunc(params.value)
            }
          }
        ],
        rowData: [] // 列表显示数据
      },
      podDialog: { // 设置目的地
        visible: false,
        warehouseCode: '',
        realCodes: '',
        curFq: null,
        gridApi: null,
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          treeData: true,
          groupDefaultExpanded: 2,
          getDataPath: data => {
            return data.path ? data.path.split(',') : ''
          },
          autoGroupColumnDef: {
            headerName: '仓库代码',
            colId: 'warehouseCode',
            field: 'warehouseCode',
            width: 240,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: true,
              checkbox: params => {
                return true
              }
            }
          }
        },
        columnDefs: [
          {
            headerName: this.$t('baseInfo.overseaWarehouse.countryChineseName'),
            field: 'countryChineseName',
            width: 100
          }, {
            headerName: this.$t('baseInfo.overseaWarehouse.countryEnglishName'),
            field: 'countryEnglishName',
            width: 100
          }, {
            headerName: this.$t('baseInfo.overseaWarehouse.country'),
            field: 'countryCode',
            width: 100,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', params.value, 'chineseName')
            }
          }, {
            headerName: this.$t('baseInfo.overseaWarehouse.province'),
            field: 'province',
            width: 100
          }, {
            headerName: this.$t('baseInfo.overseaWarehouse.city'),
            field: 'cityName',
            width: 100
          }, {
            headerName: this.$t('baseInfo.overseaWarehouse.zipCode'),
            field: 'zipCode',
            width: 80
          }, {
            headerName: this.$t('baseInfo.overseaWarehouse.address1'),
            field: 'address1',
            width: 200
          }, {
            headerName: this.$t('baseInfo.overseaWarehouse.address2'),
            field: 'address2',
            width: 200
          }, {
            headerName: this.$t('baseInfo.overseaWarehouse.address3'),
            field: 'address3',
            width: 200
          }
        ],
        rowData: [] // 列表显示数据
      },
      chargeDialog: { // 附加费维护
        visible: false,
        action: 'add', // 新增add、查看look、编辑edit
        charge: new FbaCharge().fillDefaultValue().getData()
      },
      label: { // 标签维护
        visible: false,
        isEdit: false,
        quotationLabel: new FbaQuotationLabel().fillDefaultValue().getData()
      },
      khjBjdxSelected: null, // 报价对象选中行
      khjBjdxFqSelected: null, // 报价对象-分区选中行
      fjfSelectedRow: null, // 附加费选中行
      calcMethods: FbaJobConstants.CALC_METHOD,
      tenantId: 0,
      beginDate: '',
      endDate: '',
      form: new FbaQuotation().fillDefaultValue().getData()
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    isEdit() {
      return this.operationType !== 1
    },
    isAdd() {
      return this.operationType === 2
    },
    isLook() {
      return this.operationType === 1
    },
    fqszColumns() { // 分区设置列表
      return [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true,
          pinned: 'left'
        },
        {
          headerName: '分区名称', field: 'partitionName', colId: 'partitionName', minWidth: 120,
          editable: () => !this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: (params) => {
            this.onFqszCellChange(params)
          }
        },
        {
          headerName: '目的地', field: 'pod', colId: 'pod', minWidth: 120,
          editable: () => false,
          tooltip: (params) => {
            return params.value
            // return ColumnUtils.podLabelFunc(params.data, params.value)
          },
          valueFormatter: (params) => {
            return params.value
            // return ColumnUtils.podLabelFunc(params.data, params.value)
          }
          // onCellValueChanged: (params) => {
          //   this.onFqszCellChange(params)
          // }
        }, {
          headerName: '操作',
          field: '',
          colId: '',
          width: 120,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: '设置目的地',
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.setPodHandler(params)
                },
                visible: (params) => params
              }
            ]
          }
        },
        {
          headerName: '参考时效(天)', field: 'referenceTiming', colId: 'referenceTiming', minWidth: 140,
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0')
          },
          onCellValueChanged: (params) => {
            this.onFqszCellChange(params)
          }
        }
      ]
    },
    jtszColumns() { // 阶梯设置列表
      return [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true,
          pinned: 'left'
        },
        {
          headerName: this.form.chargePartType ? '体积下限(CBM)' : '重量下限(KG)', field: 'minWeight', colId: 'minWeight', minWidth: 140,
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          },
          onCellValueChanged: (params) => {
            this.onJtszCellChange(params)
          }
        },
        {
          headerName: this.form.chargePartType ? '体积上限(CBM)' : '重量上限(KG)', field: 'maxWeight', colId: 'maxWeight', minWidth: 140,
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          },
          onCellValueChanged: (params) => {
            this.onJtszCellChange(params)
          }
        },
        {
          headerName: '计算方式', field: 'calcMethod', colId: 'calcMethod', minWidth: 120,
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: FbaJobConstants.CALC_METHOD,
            tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
            tagValue: 'code'
          },
          valueFormatter: (params) => {
            return ColumnUtils.calcMethodLabelFunc(params.value, params.data)
          },
          onCellValueChanged: (params) => {
            this.onJtszCellChange(params)
          }
        },
        {
          headerName: '计算精度', field: 'calcAccuracy', colId: 'calcAccuracy', minWidth: 140,
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 1,
              min: 0.01,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.00')
          },
          onCellValueChanged: (params) => {
            this.onJtszCellChange(params)
          }
        }
      ]
    },
    khjBjdxColumns() { // 客户价-报价对象
      return [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true,
          pinned: 'left'
        },
        {
          headerName: '报价对象', field: 'quotationObject', colId: 'quotationObject', minWidth: 120,
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: FbaJobConstants.QUOTATION_OBJECTS,
            tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
            tagValue: 'code'
          },
          valueFormatter: (params) => {
            return ColumnUtils.QuotationObjectLabelFunc(params.value, params.data)
          },
          onCellValueChanged: (params) => {
            this.onBjdxCellChange(params)
          }
        }, {
          headerName: '操作',
          field: '',
          colId: '',
          width: 120,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: '查看',
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.lookCustomerHandler(params)
                },
                visible: (params) => params && (params.quotationObject || Number(params.quotationObject) === 0)
              }
            ]
          }
        }
      ]
    },
    khjFqColumns() { // 客户价-分区
      return [
        {
          headerName: '分区名称', field: 'partitionName', colId: 'partitionName', minWidth: 100,
          editable: () => false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: (params) => {
            this.onFqszCellChange(params)
          }
        },
        {
          headerName: '目的地', field: 'pod', colId: 'pod', minWidth: 120,
          editable: () => false,
          tooltip: (params) => {
            return params.value
          },
          valueFormatter: (params) => {
            return params.value
          }
        },
        {
          headerName: '参考时效', field: 'referenceTiming', colId: 'referenceTiming', minWidth: 100,
          editable: () => false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0')
          }
        }
      ]
    },
    khjJtColumns() { // 客户价-阶梯设置列表
      return [
        {
          headerName: this.form.chargePartType ? '体积下限(CBM)' : '重量下限(KG)', field: 'minWeight', colId: 'minWeight', minWidth: 120,
          editable: () => false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: this.form.chargePartType ? '体积上限(CBM)' : '重量上限(KG)', field: 'maxWeight', colId: 'maxWeight', minWidth: 120,
          editable: () => false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: '计算方式', field: 'calcMethod', colId: 'calcMethod', minWidth: 100,
          editable: () => false,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: FbaJobConstants.CALC_METHOD,
            tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
            tagValue: 'code'
          },
          valueFormatter: (params) => {
            return ColumnUtils.calcMethodLabelFunc(params.value, params.data)
          }
        },
        {
          headerName: '计算精度', field: 'calcAccuracy', colId: 'calcAccuracy', minWidth: 100,
          editable: () => false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 1,
              min: 0.01,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: '金额', field: 'amount', colId: 'amount', minWidth: 120,
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999999,
              min: 0.01,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.00')
          },
          onCellValueChanged: (params) => {
            this.onTdszAmountCellChange(params)
          }
        }
      ]
    },
    fjfColumns() { // 客户价-报价对象
      return [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true,
          pinned: 'left'
        },
        {
          headerName: '费用名称', field: 'chargeItemId', colId: 'chargeItemId', minWidth: 120,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        {
          headerName: '附加费类型', field: 'chargeType', colId: 'chargeType', minWidth: 120,
          valueFormatter: (params) => {
            return ColumnUtils.ChargeTypeLabelFunc(params.value)
          }
        },
        {
          headerName: '币别', field: 'currency', colId: 'currency', minWidth: 120
        },
        {
          headerName: '费用描述', field: 'remark', colId: 'remark', minWidth: 120
        }
      ]
    }
  },
  methods: {
    // 编辑
    toEdit() {
      if (!this.form.uuid) {
        return
      }
      this.initData()
      this.onShow(this.form, 3)
    },
    // 详情显示
    onShow(row, operationType) {
      const user = getUserInfo()
      this.tenantId = user.tenantId
      this.operationType = operationType
      this.showNextOne = this.showNextTwo = this.showNextThree = !this.isAdd // 只有新增显示下一步
      Object.assign(this.form, row)
      this.loadChargeItem()
      this.loadSalesPrivateCustomer()
      // 加载报价单所有数据
      this.initQuotationInfo()
      this.initCustomSearchItems()
    },
    async initQuotationInfo() {
      if (this.isAdd) { // 新增初始化数据
        this.form.beginDate = moment(new Date()).format('YYYY-MM-DD')
        this.form.endDate = moment(new Date()).add(7, 'days').format('YYYY-MM-DD')
        this.form.currency = 'RMB'
        getQuotationAvailableChannels({ tenantId: this.tenantId, active: this.form.active, beginDate: this.form.beginDate, endDate: this.form.endDate }).then(res => {
          this.channel4QuotationSelect = res.data.channelList
        })
      } else { // 从数据库里面获取数据
        const jobModel = new FbaQuotation(this.form)
        await jobModel.loadFbaQuotationRelated({
          quotation: true,
          label: true,
          partitionSetting: true,
          setupSetting: true,
          charge: true,
          customerPrice: true
        })
      }
      // 数据初始化
      this.beginDate = this.form.beginDate
      this.endDate = this.form.endDate
      if (!this.form.partitionSettingList) this.form.partitionSettingList = []
      if (!this.form.setupSettingList) this.form.setupSettingList = []
      if (!this.form.customerPriceList) this.form.customerPriceList = []
      if (!this.form.chargeList) this.form.chargeList = []

      this.$logger.log('报价管理-==================', this.form)
      // 渠道信息处理
      this.channelInfo()

      // 给每个表格赋值
      this.fqsz.rowData = this.form.partitionSettingList // 分区
      this.jtsz.rowData = this.form.setupSettingList // 梯度
      this.khjBjdx.rowData = this.form.customerPriceList // 客户价-报价对象
      this.fjf.rowData = this.form.chargeList // 附加费

      this.khjBjdxSelected = null // 客户价-报价对象
      if (this.khjBjdx.gridApi) {
        this.khjBjdx.gridApi.clearFocusedCell()
        this.khjBjdx.gridApi.refreshCells({ force: true })
      }
      this.khjBjdxFqSelected = null // 客户价-报价对象-分区
      if (this.khjFq.gridApi) {
        this.khjFq.gridApi.clearFocusedCell()
        this.khjFq.gridApi.refreshCells({ force: true })
      }
    },
    async initCustomSearchItems() {
      const searchFields = []
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'ow.CITY_CODE'
      searchField.itemLabel = 'SeaExport.City'
      searchField.tagValue = 'code'
      searchField.defaultSelected = 1
      searchField.defaultValue = ''
      searchField.dataProvider = await getLocationList({}).then((res) => {
        return res.data.list || []
      })
      searchFields.push(searchField.formatObj2Json())
      this.customSearchItems = searchFields
    },
    // 客户属性过滤
    customerIdFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customer && item.fba && item.active
    },
    // 渠道信息
    channelInfo() {
      // 获取货物类型
      this.fbaCargoType = []
      if (this.fbaCargoType && this.fbaCargoType.length === 0) {
        const res = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CargoType)
        for (const item of res) {
          switch (this.form.shippingType) {
            case 'SE':
              if (item.fbaSea) {
                this.fbaCargoType.push(item)
              }
              break
            case 'AE':
              if (item.fbaAir) {
                this.fbaCargoType.push(item)
              }
              break
            case 'RE':
              if (item.fbaRailway) {
                this.fbaCargoType.push(item)
              }
              break
            default:
              if (item.fbaSea || item.fbaAir || item.fbaRailway) {
                this.fbaCargoType.push(item)
              }
          }
        }
      }
      // 转换货物类型
      if (this.form.acceptableGoods && this.form.acceptableGoods.split(',').length > 0) {
        this.acceptableGoods = this.form.acceptableGoods.split(',')
      }
      // 计费区间类型，优先取渠道的，渠道没有取本身
      if (this.form && this.form.chargingMethod || typeof this.form.chargingMethod === 'number') {
        this.form.chargePartType = Number(this.form.chargingMethod)
      } else {
        this.form.chargePartType = Number(this.form.chargePartType)
      }
    },
    // 添加标签
    onAddLabel() {
      if (!this.isEdit) return
      const quotationLabel = new FbaQuotationLabel().fillDefaultValue().getData()
      quotationLabel.tmpUuid = UIDUtil.createUID()
      quotationLabel.backgroundColor = '#1B90FF'
      quotationLabel.textColor = '#ffffff'
      this.label.quotationLabel = quotationLabel
      this.label.visible = true
    },
    loadSalesPrivateCustomer() {
      const user = getUserInfo()
      const companyList = getCacheListByKey(basicCacheKeys.basic_data_Company)
      this.customerCmpList = null
      if (!user.admin && !this.$checkPermission(['button_FBAOrder_selectAllCustomerFBA']) && (this.$checkPermission(['button_FBAOrder_selectSalesCustomerFBA']) || this.$checkPermission(['button_FBAOrder_selectDepartmentCustomerFBA']))) {
        getFbaCustomerByRole({ branch: this.$store.getters.currentOfficeId }).then(res => {
          this.customerCmpList = companyList.filter(p => res.data.includes(p.cmpIdx) && p.customer && p.fba && p.active)
        })
      }
    },
    loadChargeItem() {
      const chargeItemList = getCacheListByKey(basicCacheKeys.basic_data_ChargeItem)
      switch (this.form.shippingType) {
        case 'SE':
          this.chargeItemList = chargeItemList.filter(p => (p.fbaSea) && p.active && p.surcharge)
          break
        case 'AE':
          this.chargeItemList = chargeItemList.filter(p => (p.fbaAir) && p.active && p.surcharge)
          break
        case 'RE':
          this.chargeItemList = chargeItemList.filter(p => (p.fbaRailway) && p.active && p.surcharge)
          break
        default:
          this.chargeItemList = chargeItemList.filter(p => (p.fbaSea || p.fbaAir || p.fbaRailway) && p.active && p.surcharge)
      }
    },
    // 删除标签
    handleTagClose(item) {
      if (!item || !this.isEdit) return
      for (const obj of this.form.labelList) {
        if ((item.tmpUuid && obj.tmpUuid === item.tmpUuid) || (item.uuid && obj.uuid === item.uuid)) {
          const index = this.form.labelList.indexOf(item)
          if (index !== -1) {
            this.form.labelList.splice(index, 1)
          }
        }
        if (item.uuid && !this.deleteLabelUuids.includes(item.uuid)) {
          this.deleteLabelUuids.push(item.uuid)
        }
      }
    },
    // 编辑标签
    editTag(item) {
      if (!item || !this.isEdit) return
      this.label.isEdit = true
      this.label.quotationLabel = item
      this.label.visible = true
    },
    // 保存标签
    toLabel() {
      if (!this.label.quotationLabel.labelName) {
        this.$message.warning('标签名称不能为空。')
        return
      }
      if (!this.form.labelList) this.form.labelList = []
      this.label.quotationLabel.updated = true
      if (!this.label.isEdit) this.form.labelList.push(this.label.quotationLabel)
      this.label.visible = false
    },
    // 更改折叠面板
    handleChange() {
    },
    // 返回
    toBackList() {
      this.$refs.form.resetFields()
      this.$emit('backList')
    },
    // 保存
    doSave() {
      this.loading = getLoading4Cxt(this)
      // 默认当前分公司
      this.form.branchId = this.$store.getters.currentOfficeId
      // 保存前验证
      if (!this.check()) {
        this.loading.close()
        return
      }
      // 删除数据组装
      this.getDeleteData()
      save(this.form).then(res => {
        this.form.uuid = res.data.uuid
        this.initData()
        this.onShow(this.form, 1)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 获取删除数据
    getDeleteData() {
      this.form.deleteLabelUuids = this.deleteLabelUuids
      this.form.deletePartitionSettingUuids = this.deletePartitionSettingUuids
      this.form.deleteSetupSettingUuids = this.deleteSetupSettingUuids
      this.form.deleteChargeUuids = this.deleteChargeUuids
      this.form.deleteChargeSceneUuids = this.deleteChargeSceneUuids
      this.form.deleteCustomerPriceUuids = this.deleteCustomerPriceUuids
    },
    // 初始化删除数据
    initData() {
      for (const key in this.form) {
        if (this.form[key] && typeof this.form[key] === 'object') {
          this.form[key] = null
        }
      }
      this.form.deleteLabelUuids = this.deleteLabelUuids = []
      this.form.deletePartitionSettingUuids = this.deletePartitionSettingUuids = []
      this.form.deleteSetupSettingUuids = this.deleteSetupSettingUuids = []
      this.form.deleteChargeUuids = this.deleteChargeUuids = []
      this.form.deleteChargeSceneUuids = this.deleteChargeSceneUuids = []
      this.form.deleteCustomerPriceUuids = this.deleteCustomerPriceUuids = []
    },
    // 保存前验证
    check() {
      if (!this.form.serviceChannel) {
        this.$message.warning('渠道名称不能为空。')
        return false
      }
      if ((!this.form.beginDate || !this.form.endDate) && !this.form.active) {
        this.$message.warning('报价有效期不能为空。')
        return false
      }
      // 标签
      if (this.form.labelList && this.form.labelList.length > 0) {
        for (const label of this.form.labelList) {
          if (!label.labelName) {
            this.$message.warning('标签名称不能为空。')
            return false
          }
        }
      }
      // 分区
      if (!this.form.partitionSettingList || this.form.partitionSettingList.length <= 0) {
        this.$message.warning('至少设置一个分区。')
        return false
      }
      if (this.form.partitionSettingList && this.form.partitionSettingList.length > 0) {
        for (const partitionSetting of this.form.partitionSettingList) {
          if (!partitionSetting.pod) {
            this.$message.warning(partitionSetting.partitionName + '至少设置一个目的地。')
            return false
          }
          if (!partitionSetting.referenceTiming) {
            this.$message.warning(partitionSetting.partitionName + '参考时效不能为空。')
            return false
          }
        }
      }
      // 阶梯
      if (!this.form.setupSettingList || this.form.setupSettingList.length <= 0) {
        this.$message.warning('至少设置一个重量区间。')
        return false
      }
      if (this.form.setupSettingList && this.form.setupSettingList.length > 0) {
        for (const setupSetting of this.form.setupSettingList) {
          if (!setupSetting.minWeight || Number(setupSetting.minWeight) === 0) {
            const minWeightMsg = this.form.chargePartType ? '体积下限' : '重量下限'
            this.$message.warning(minWeightMsg + '不能为空。')
            return false
          }
          if (!setupSetting.maxWeight || Number(setupSetting.maxWeight) === 0) {
            const maxWeightMsg = this.form.chargePartType ? '体积上限' : '重量上限'
            this.$message.warning(maxWeightMsg + '不能为空。')
            return false
          }
          if (!setupSetting.calcAccuracy || Number(setupSetting.calcAccuracy) === 0) {
            this.$message.warning('计算精度不能为空。')
            return false
          }
        }
      }
      // 客户价
      if (!this.form.customerPriceList || this.form.customerPriceList.length <= 0) {
        this.$message.warning('至少配置一个客户价。')
        return false
      }
      for (const customerPrice of this.form.customerPriceList) {
        if (!customerPrice.quotationObject && customerPrice.quotationObject !== 0) {
          this.$message.warning('报价对象不能为空。')
          return false
        }
      }
      // 附加费
      if (this.form.chargeList && this.form.chargeList.length > 0) {
        for (const charge of this.form.chargeList) {
          if (!charge.chargeItemId) {
            this.$message.warning('附加费名称不能为空。')
            return false
          }
          if (!charge.chargeType && charge.chargeType !== 0) {
            this.$message.warning('附加费类型不能为空。')
            return false
          }
          if (!charge.currency) {
            this.$message.warning('币别不能为空。')
            return false
          }
        }
      }
      return true
    },
    // 取消
    cancel() {
      if (this.form && this.form.uuid) { // 编辑的话就变成查看，新增的话就返回到列表
        this.initData()
        this.onShow(this.form, 1)
      } else {
        this.toBackList()
      }
    },
    // 预览报价
    preQuotation() {

    },
    // 设置不可选日期范围
    disabledBeginDate(time) {
      const beginDate = new Date().getTime()
      const dateRegion = beginDate - 1 * 24 * 3600 * 1000
      const flag = time.getTime() < dateRegion
      if (this.endDate) {
        const endDate = new Date(this.endDate).getTime()
        return flag && time.getTime() < endDate
      }
      return flag
    },
    // 设置不可选日期范围
    disabledDate(time) {
      const dateRegion = new Date().getTime() - 1 * 24 * 3600 * 1000
      return time.getTime() < dateRegion
    },
    // 改变报价有效期
    changeDate(type = true) {
      if (this.beginDate && this.endDate) {
        const beginDate = moment(this.beginDate).format('YYYY-MM-DD')
        const endDate = moment(this.endDate).format('YYYY-MM-DD')
        if (endDate < beginDate) {
          this.$message.warning('有效期结束时间不能小于开始时间。')
          if (type) this.endDate = this.form.endDate
          if (!type) this.beginDate = this.form.beginDate
          return
        }
        getQuotationAvailableChannels({ quotationNo: this.form.quotationNo, tenantId: this.tenantId, active: this.form.active, beginDate: this.beginDate, endDate: this.endDate }).then(res => {
          if (this.form.serviceChannel && !res.data.channelList.find(e => this.form.serviceChannel === e.channelName)) {
            this.$message.warning('当前有效期内已存在相同渠道的报价单（' + res.data.quotationList.find(e => this.form.serviceChannel === e.serviceChannel).quotationNo + '）！')
            if (type) this.endDate = this.form.endDate
            if (!type) this.beginDate = this.form.beginDate
          } else {
            this.form.endDate = this.endDate
            this.form.beginDate = this.beginDate
            this.channel4QuotationSelect = res.data.channelList
          }
        })
      }
    },
    setChannelData(channel) {
      this.form.shippingType = channel.shippingType
      this.form.destinationDistribution = channel.destinationDistribution
      this.form.chargingMethod = channel.chargingMethod
      this.form.bubbleCountingRatio = channel.bubbleCountingRatio
      this.form.bubbleSplittingRatio = channel.bubbleSplittingRatio
      this.form.singleBoxLowestBillableWeight = channel.singleBoxLowestBillableWeight
      this.form.multipleBoxesCalculationRules = channel.multipleBoxesCalculationRules
      this.form.settlementWeightRoundingRules = channel.settlementWeightRoundingRules
      this.form.acceptableGoods = channel.acceptableGoods
    },
    // 更改渠道名称
    changeChannel(channel) {
      this.setChannelData(channel)
      // 渠道信息处理
      this.channelInfo()
    },
    async changeChannelName(channelName) {
      await getQuotationAvailableChannels({ tenantId: this.tenantId, active: this.form.active, beginDate: this.beginDate, endDate: this.endDate }).then(res => {
        if (!res.data.channelList.find(e => channelName === e.channelName)) {
          this.$message.warning('当前有效期内已存在相同渠道的报价单（' + res.data.quotationList.find(e => this.form.serviceChannel === e.serviceChannel).quotationNo + '）！')
          this.form.serviceChannel = ''
        } else {
          this.channel4QuotationSelect = res.data.channelList
          const channel = this.channel4QuotationSelect.find(e => channelName === e.channelName)
          this.setChannelData(channel)
          // 渠道信息处理
          this.channelInfo()
        }
      })
      this.loadChargeItem()
      // 计费区间类型，优先取渠道的，渠道没有取本身
      if (this.form && this.form.chargingMethod || typeof this.form.chargingMethod === 'number') {
        this.form.chargePartType = Number(this.form.chargingMethod)
      } else {
        this.form.chargePartType = Number(this.form.chargePartType)
      }
    },
    // 勾选长期有效
    changeActive() {
      getQuotationAvailableChannels({ quotationNo: this.form.quotationNo, tenantId: this.tenantId, active: this.form.active, beginDate: this.beginDate, endDate: this.endDate }).then(res => {
        if (this.form.serviceChannel && !res.data.channelList.find(e => this.form.serviceChannel === e.channelName)) {
          this.$message.warning('当前有效期内已存在相同渠道的报价单（' + res.data.quotationList.find(e => this.form.serviceChannel === e.serviceChannel).quotationNo + '）！')
          this.form.active = false
        } else {
          this.beginDate = ''
          this.endDate = ''
          this.form.beginDate = ''
          this.form.endDate = ''
          this.channel4QuotationSelect = res.data.channelList
        }
      })
    },
    // ==========================分区梯度 ====================
    // 添加分区
    addPartitionSetting() {
      if (this.fqsz.rowData.length === 50) {
        this.$message.warning('分区最多添加50个。')
        return
      }
      const item = new FbaPartitionSetting().fillDefaultValue().getData()
      item.quotationUuid = this.form.uuid
      item.tmpUuid = UIDUtil.createUID()
      item.serialNumber = this.fqsz.rowData.length + 1
      item.partitionName = item.serialNumber + '区'
      this.fqsz.rowData.push(item)

      // 添加分区的时候同步添加每个客户价的分区信息
      if (this.khjBjdx.rowData && this.khjBjdx.rowData.length > 0) {
        for (const curKhj of this.khjBjdx.rowData) {
          if (!curKhj.fqRowData) curKhj.fqRowData = []
          const fqItem = lodash.cloneDeep(item)
          // 添加客户加分区的时候，也需要将阶梯加进去
          fqItem.tdRowData = lodash.cloneDeep(this.jtsz.rowData) || []
          curKhj.fqRowData.push(fqItem)
        }
      }
    },
    // 删除分区
    deletePartitionSetting() {
      const chooseRows = this.fqsz.gridApi.getSelectedRows()
      if (chooseRows.length <= 0) {
        this.$message.warning('请选择要删除的分区。')
        return
      }
      if (this.fqsz.rowData.length <= chooseRows.length) {
        this.$message.warning('分区不能全部删除，最少留1个。')
        return
      }
      let flag = false // 是否执行客户价 分区信息的刷新
      for (const item of chooseRows) {
        item.deleted = true
        item.quotationUuid = ''
        // 删除数据库
        if (item.uuid) {
          this.deletePartitionSettingUuids.push(item.uuid)
        }
        // 删除列表
        for (const obj of this.fqsz.rowData) {
          if ((item.tmpUuid && obj.tmpUuid === item.tmpUuid) || (item.uuid && obj.uuid === item.uuid)) {
            const index = this.fqsz.rowData.indexOf(item)
            if (index !== -1) {
              this.fqsz.rowData.splice(index, 1)
            }
          }
        }
        // 改变后续的区名
        for (const obj of this.fqsz.rowData) {
          if (obj.serialNumber > item.serialNumber) {
            obj.serialNumber = obj.serialNumber - 1
            obj.partitionName = obj.serialNumber + '区'
            obj.updated = true
            this.syncKhjFqInfo(obj)
          }
        }

        // 删除分区的时候同步删除每个客户价的分区信息
        if (this.khjBjdx.rowData && this.khjBjdx.rowData.length > 0) {
          for (const curKhj of this.khjBjdx.rowData) {
            if (!curKhj.fqRowData || curKhj.fqRowData.length <= 0) {
              continue
            }
            for (const curFq of curKhj.fqRowData) {
              if ((item.tmpUuid && curFq.tmpUuid === item.tmpUuid) || (item.uuid && curFq.uuid === item.uuid)) {
                const index = curKhj.fqRowData.indexOf(curFq)
                if (index !== -1) {
                  if (!flag) flag = true
                  curKhj.fqRowData.splice(index, 1)
                }
              }
            }
          }
        }
      }
      this.$logger.log('deletePartitionSetting=====', this.form.partitionSettingList)
      this.fqsz.gridApi.refreshCells({ force: true }) // 刷新
      if (flag) {
        this.khjBjdxFqSelected = null
        this.khjFq.gridApi.refreshCells({ force: true }) // 刷新
      }
    },
    // 分区设置列编辑
    onFqszCellChange(params) {
      // const field = params.colDef.field
      const curItem = params.data
      curItem.updated = true
      this.fqsz.gridApi.refreshCells({ force: true }) // 刷新
      this.syncKhjFqInfo(curItem)
    },
    // 分区列编辑同步客户价分区信息
    syncKhjFqInfo(curItem) {
      if (this.khjBjdx.rowData && this.khjBjdx.rowData.length > 0) {
        for (const curKhj of this.khjBjdx.rowData) {
          if (!curKhj.fqRowData || curKhj.fqRowData.length <= 0) {
            continue
          }
          for (const curFq of curKhj.fqRowData) {
            if ((curItem.tmpUuid && curFq.tmpUuid === curItem.tmpUuid) || (curItem.uuid && curFq.uuid === curItem.uuid)) {
              for (const key in curFq) {
                if (typeof curFq[key] === 'object') {
                  continue
                }
                curFq[key] = curItem[key]
              }
            }
          }
        }
        this.khjFq.gridApi.refreshCells({ force: true }) // 刷新
      }
    },
    // 设置目的地
    setPodHandler(params) {
      if (!this.isEdit) return
      this.podDialog.curFq = params
      this.podDialog.realCodes = params.pod || ''
      this.podDialog.warehouseCode = ''
      this.podDialog.visible = true
      this.fetchDataByKeyWord()
    },
    // 根据仓库代码查询
    fetchDataByKeyWord(keyWord = '') {
      const loading = getLoading()
      const filter = {
        pageNum: 1,
        pageSize: 5000
      }
      filter.tenantId = this.tenantId
      filter.likeName = keyWord
      const params = { ...filter }
      getOverseaWarehouseList(params).then(res => {
        const overseaWarehouses = res.data.list
        const fathers = [
          { path: '1', parentUuid: '1', warehouseCode: '亚马逊仓' },
          { path: '2', parentUuid: '2', warehouseCode: '国外仓' }
        ]
        const childs = []
        const realCodes = this.podDialog.realCodes.split(',')
        let fbaCount = 0
        let realFbaCount = 0
        let overseaCount = 0
        let realOverseaCount = 0
        for (const item of overseaWarehouses) {
          if (item.ifFba) {
            item.path = '1,' + item.uuid
            item.parentUuid = '1'
            fbaCount++
          } else {
            item.path = '2,' + item.uuid
            item.parentUuid = '2'
            overseaCount++
          }
          if (realCodes.includes(item.warehouseCode)) {
            if (item.ifFba) {
              realFbaCount++
            } else {
              realOverseaCount++
            }
            childs.unshift(item)
          } else {
            childs.push(item)
          }
        }
        this.podDialog.rowData = [...fathers, ...childs]
        // 如果一开始有，则打开的时候默认选中
        this.$nextTick(async() => {
          await ensureExecuteSuccess(() => this.podDialog.gridApi)
          if (this.podDialog.realCodes && this.podDialog.gridApi) {
            this.podDialog.gridApi.forEachNode(node => {
              const curItem = node.data
              if (realCodes.includes(curItem.warehouseCode)) {
                node.setSelected(true)
              }
              if (curItem.warehouseCode === '亚马逊仓' && fbaCount === realFbaCount) {
                node.setSelected(true)
              }
              if (curItem.warehouseCode === '国外仓' && overseaCount === realOverseaCount) {
                node.setSelected(true)
              }
            })
          }
          if (this.podDialog.gridApi) this.podDialog.gridApi.clearFocusedCell()
        })
      }).finally(() => loading.close())
    },
    // 高级查询
    fetchData(dataConditions) {
      const conditions = []
      conditions.push(...dataConditions)
      const requestBody = { conditions, branchId: this.$store.getters.currentOfficeId }
      this.loading = getLoading4Cxt()
      advanceQuery(requestBody).then(res => {
        const overseaWarehouses = res.data
        const fathers = [
          { path: '1', parentUuid: '1', warehouseCode: '亚马逊仓' },
          { path: '2', parentUuid: '2', warehouseCode: '国外仓' }
        ]
        const childs = []
        for (const item of overseaWarehouses) {
          item.path = item.ifFba ? ('1,' + item.uuid) : ('2,' + item.uuid)
          item.parentUuid = item.ifFba ? '1' : '2'
          childs.push(item)
        }
        this.podDialog.rowData = [...fathers, ...childs]
        const realCodes = this.podDialog.realCodes.split(',')
        for (let i = 0; i < this.podDialog.rowData.length; i++) {
          if (realCodes.includes(this.podDialog.rowData[i].warehouseCode)) {
            this.podDialog.rowData.splice(0, 0, this.podDialog.rowData.splice(i, 1)[0])
            i--
          }
        }
        // 如果一开始有，则打开的时候默认选中
        this.$nextTick(async() => {
          await ensureExecuteSuccess(() => this.podDialog.gridApi)
          if (this.podDialog.realCodes && this.podDialog.gridApi) {
            this.podDialog.gridApi.forEachNode(node => {
              const curItem = node.data
              if (realCodes.includes(curItem.warehouseCode)) {
                node.setSelected(true)
              }
            })
          }
          if (this.podDialog.gridApi) this.podDialog.gridApi.clearFocusedCell()
        })
      }).finally(() => {
        this.loading.close()
      })
    },
    // 确认选中目的地
    confirmPod() {
      let realCodes = this.podDialog.realCodes.split(',')
      this.podDialog.gridApi.forEachNode(node => {
        const curItem = node.data
        if (realCodes.includes(curItem.warehouseCode)) {
          if (!node.selected) {
            realCodes.splice(realCodes.indexOf(curItem.warehouseCode), 1)
          }
        } else {
          if (node.selected && node.path !== '1' && node.path !== '2') {
            realCodes.push(curItem.warehouseCode)
          }
        }
      })
      if (realCodes.length === 0) {
        this.$message.warning('请选择目的地。')
        return
      }
      let result = false
      let area = 0
      for (const each of this.fqsz.rowData) {
        area++
        if (each.partitionName === this.podDialog.curFq.partitionName) {
          continue
        }
        const podArr = each.pod.split(',')
        for (const item of realCodes) {
          if (podArr.includes(item)) {
            result = true
            break
          }
        }
        if (result) {
          break
        }
      }
      if (result) {
        this.$message.warning('已在' + area + '区维护相同的海外仓，请检查')
        return
      }
      realCodes = realCodes.filter(p => p && p !== '亚马逊仓' && p !== '国外仓')
      this.podDialog.curFq.pod = realCodes.join(',')
      this.podDialog.curFq.updated = true
      this.podDialog.visible = false

      // 这个刷新必须要，否则界面不显示
      this.fqsz.gridApi.refreshCells({ force: true })

      this.syncKhjFqInfo(this.podDialog.curFq)
    },
    // 添加梯度
    addSetupSetting() {
      let oldSetupSetting = null
      if (this.jtsz.rowData && this.jtsz.rowData.length > 0) {
        const lastData = this.jtsz.rowData[this.jtsz.rowData.length - 1]
        if (!lastData.maxWeight || Number(lastData.maxWeight) <= 0 || !lastData.minWeight || Number(lastData.minWeight) <= 0) {
          this.$message.warning('请先维护第' + this.jtsz.rowData.length + '梯度数据后，再继续添加梯度。')
          return
        }
        oldSetupSetting = this.jtsz.rowData[0]
      }
      const item = new FbaSetupSetting().fillDefaultValue().getData()
      item.quotationUuid = this.form.uuid
      item.tmpUuid = UIDUtil.createUID()
      if (oldSetupSetting) {
        item.calcMethod = oldSetupSetting.calcMethod
        if (item.calcMethod === FbaJobConstants.CALC_FIRST_WEIGHT.code) {
          item.calcMethod = FbaJobConstants.CALC_WEIGHT_CONTINUATION.code
        }
      }
      item.calcAccuracy = 1.00
      this.jtsz.rowData.push(item)

      // 添加梯度的时候同步添加每个客户价每个分区的阶梯信息
      if (this.khjBjdx.rowData && this.khjBjdx.rowData.length > 0) {
        for (const curKhj of this.khjBjdx.rowData) {
          if (!curKhj.fqRowData || curKhj.fqRowData.length <= 0) {
            continue
          }
          for (const curFq of curKhj.fqRowData) {
            if (!curFq.tdRowData) curFq.tdRowData = []
            const tdItem = lodash.cloneDeep(item)
            tdItem.amount = 0.01
            curFq.tdRowData.push(tdItem)
          }
        }
        this.khjJt.gridApi.setRowData(this.khjBjdxFqSelected.tdRowData || [])
      }
    },
    // 删除梯度
    deleteSetupSetting() {
      const chooseRows = this.jtsz.gridApi.getSelectedRows()
      if (chooseRows.length <= 0) {
        this.$message.warning('请选择要删除的梯度。')
        return
      }
      if (this.jtsz.rowData.length <= chooseRows.length) {
        this.$message.warning('梯度不能全部删除，最少留1个。')
        return
      }
      let flag = false // 是否执行客户价 阶梯信息的刷新
      for (const item of chooseRows) {
        item.deleted = true
        item.quotationUuid = ''
        // 删除数据库
        if (item.uuid && !this.deleteSetupSettingUuids.includes(item.uuid)) {
          this.deleteSetupSettingUuids.push(item.uuid)
        }
        // 删除列表
        for (const obj of this.jtsz.rowData) {
          if ((item.tmpUuid && obj.tmpUuid === item.tmpUuid) || (item.uuid && obj.uuid === item.uuid)) {
            const index = this.jtsz.rowData.indexOf(item)
            if (index !== -1) {
              this.jtsz.rowData.splice(index, 1)
            }
          }
        }
        // 如果梯度剩下最后一条，且计算方式是续重，则需要将续重改成首重
        if (this.jtsz.rowData.length === 1) {
          for (const obj of this.jtsz.rowData) {
            if (obj.calcMethod === FbaJobConstants.CALC_WEIGHT_CONTINUATION.code) {
              obj.calcMethod = FbaJobConstants.CALC_FIRST_WEIGHT.code
              obj.updated = true
            }
          }
        }
        // 删除梯度的时候同步删除每个客户价每个分区的阶梯信息
        if (this.khjBjdx.rowData && this.khjBjdx.rowData.length > 0) {
          for (const curKhj of this.khjBjdx.rowData) {
            if (!curKhj.fqRowData || curKhj.fqRowData.length <= 0) {
              continue
            }
            for (const curFq of curKhj.fqRowData) {
              if (!curFq.tdRowData) continue
              // 删除每个分区的阶梯信息
              for (const curTd of curFq.tdRowData) {
                if ((item.tmpUuid && curTd.tmpUuid === item.tmpUuid) || (item.uuid && curTd.uuid === item.uuid)) {
                  const index = curFq.tdRowData.indexOf(curTd)
                  if (index !== -1) {
                    if (!flag) flag = true
                    curFq.tdRowData.splice(index, 1)
                  }
                }
              }
            }
          }
        }
      }
      this.$logger.log('deleteSetupSetting=====', this.form.partitionSettingList)
      this.jtsz.gridApi.refreshCells({ force: true }) // 刷新
      if (flag) {
        this.khjJt.gridApi.setRowData(this.khjBjdxFqSelected.tdRowData || [])
        this.khjJt.gridApi.refreshCells({ force: true }) // 刷新
      }
    },
    // 阶梯设置列编辑
    onJtszCellChange(params) {
      const field = params.colDef.field
      const curItem = params.data
      const oldValue = params.oldValue
      curItem.updated = true
      if ((field === 'maxWeight' || field === 'minWeight')) {
        if (Number(curItem.maxWeight) <= Number(curItem.minWeight) && (curItem.minWeight && Number(curItem.minWeight) !== 0) && (curItem.maxWeight && Number(curItem.maxWeight) !== 0)) {
          this.$message.warning('上限不能低于下限，请检查。')
          curItem[field] = oldValue
        }
        if (curItem[field] < 0) {
          curItem[field] = 0
        }
      } else if (field === 'calcMethod') {
        if (params.oldValue === FbaJobConstants.CALC_WEIGHT_CONTINUATION.code && params.newValue !== FbaJobConstants.CALC_UNIT_PRICE.code && params.newValue !== FbaJobConstants.CALC_TOTAL_AMOUNT.code) {
          this.$message.warning('如果修改续重的计算方式，只能修改为单价/总金额，不能改为首重')
          curItem.calcMethod = params.oldValue
        } else if (params.oldValue === FbaJobConstants.CALC_FIRST_WEIGHT.code && params.newValue !== FbaJobConstants.CALC_UNIT_PRICE.code && params.newValue !== FbaJobConstants.CALC_TOTAL_AMOUNT.code) {
          this.$message.warning('如果修改首重重的计算方式，只能修改为单价/总金额，不能改为续重')
          curItem.calcMethod = params.oldValue
        } else if ((params.newValue === FbaJobConstants.CALC_FIRST_WEIGHT.code || params.newValue === FbaJobConstants.CALC_WEIGHT_CONTINUATION.code) && (params.oldValue === FbaJobConstants.CALC_UNIT_PRICE.code || params.oldValue === FbaJobConstants.CALC_TOTAL_AMOUNT.code)) {
          for (let i = 0; i < this.jtsz.rowData.length; i++) {
            const curJt = this.jtsz.rowData[i]
            if (i === 0) {
              curJt.calcMethod = FbaJobConstants.CALC_FIRST_WEIGHT.code
              continue
            }
            curJt.calcMethod = FbaJobConstants.CALC_WEIGHT_CONTINUATION.code
          }
        } else {
          for (const curJt of this.jtsz.rowData) {
            curJt.updated = true
            curJt.calcMethod = curItem.calcMethod
          }
        }
      } else if (field === 'calcAccuracy') {
        if (Number(curItem[field]) <= 0) {
          curItem[field] = 1.00
        }
        if (Number(curItem[field]) > 1) {
          curItem[field] = 1.00
        }
      }

      // 计算方式为单价和总金额的后面的梯度区间值不能介于前面所有梯度区间
      // 提示：第二梯度（变量）区间不能介于第一梯度（变量）区间
      let flag = false
      let baseIdx = 0
      const curIdx = this.jtsz.rowData.indexOf(curItem)
      if ((curItem.calcMethod === FbaJobConstants.CALC_UNIT_PRICE.code || curItem.calcMethod === FbaJobConstants.CALC_TOTAL_AMOUNT.code) && this.jtsz.rowData.length > 1) {
        for (let i = 0; i < this.jtsz.rowData.length; i++) {
          if (curIdx === i) {
            continue
          }
          const baseJt = this.jtsz.rowData[i]
          const minWeight = Number(baseJt.minWeight)
          const maxWeight = Number(baseJt.maxWeight)
          const curMinWeight = Number(curItem.minWeight)
          const curMaxWeight = Number(curItem.maxWeight)
          if (minWeight !== 0 && maxWeight !== 0 &&
              ((curMinWeight >= minWeight && curMinWeight <= maxWeight) || (curMaxWeight >= minWeight && curMaxWeight <= maxWeight) || (curMinWeight <= minWeight && curMaxWeight >= maxWeight))) {
            flag = true
            baseIdx = i
          }
          if (flag) {
            this.$message.warning('第' + (curIdx + 1) + '梯度区间不能介于第' + (baseIdx + 1) + '梯度（变量）区间。')
            curItem[field] = oldValue
            break
          }
        }
      }

      this.jtsz.gridApi.refreshCells({ force: true }) // 刷新
      this.syncKhjTdInfo(curItem, field === 'calcMethod')
    },
    // 分区列编辑同步客户价分区信息
    syncKhjTdInfo(curItem, isCalcMethod) {
      if (this.khjBjdx.rowData && this.khjBjdx.rowData.length > 0) {
        for (const curKhj of this.khjBjdx.rowData) {
          if (!curKhj.fqRowData || curKhj.fqRowData.length <= 0) {
            continue
          }
          for (const curFq of curKhj.fqRowData) {
            if (!curFq.tdRowData) continue
            // 同步每个分区的阶梯信息
            for (const curTd of curFq.tdRowData) {
              if ((curItem.tmpUuid && curTd.tmpUuid === curItem.tmpUuid) || (curItem.uuid && curTd.uuid === curItem.uuid)) {
                for (const key in curTd) {
                  if (key === 'amount') continue
                  curTd[key] = curItem[key]
                }
              }
              if (isCalcMethod) {
                for (let i = 0; i < this.jtsz.rowData.length; i++) {
                  const curJt = this.jtsz.rowData[i]
                  if ((curJt.tmpUuid && curTd.tmpUuid === curJt.tmpUuid) || (curJt.uuid && curTd.uuid === curJt.uuid)) {
                    curTd.calcMethod = curJt.calcMethod
                  }
                }
              }
            }
          }
        }
        this.khjJt.gridApi.refreshCells({ force: true }) // 刷新
      }
    },
    // ==========================客户价 ====================
    // 报价对象列编辑
    onBjdxCellChange(params) {
      // const field = params.colDef.field
      const curItem = params.data
      if ((curItem.quotationObject || curItem.quotationObject === 0) && this.khjBjdx.rowData && this.khjBjdx.rowData.length > 0) {
        const map = new Map()
        for (const curObj of this.khjBjdx.rowData) {
          if (map.has(curItem.quotationObject)) {
            this.$message.warning('当前添加的报价对象已存在。')
            const index = this.khjBjdx.rowData.indexOf(curItem)
            if (index !== -1) {
              this.khjBjdx.rowData.splice(index, 1)
            }
            return
          }
          map.set(curObj.quotationObject, curObj.quotationObject)
        }
      }
      curItem.updated = true
      this.khjBjdx.gridApi.refreshCells({ force: true }) // 刷新
    },
    // 添加客户价
    addCustomerPrice() {
      if (this.khjBjdx.rowData.length === 10) {
        this.$message.warning('客户价最多可添加10个。')
        return
      }
      // 报价对象列表
      const item = new FbaCustomerPrice().fillDefaultValue().getData()
      item.quotationUuid = this.form.uuid
      item.tmpUuid = UIDUtil.createUID()
      // 报价对象关联的分区列表
      item.fqRowData = lodash.cloneDeep(this.fqsz.rowData) || []
      this.khjBjdxSelected = item
      // 分区关联的梯度列表
      if (item.fqRowData && item.fqRowData.length > 0) {
        for (const fqItem of item.fqRowData) {
          fqItem.tdRowData = lodash.cloneDeep(this.jtsz.rowData) || []
          for (const td of fqItem.tdRowData) {
            td.amount = 0.01
          }
        }
        this.khjBjdxFqSelected = item.fqRowData[0]
      }
      this.khjBjdx.rowData.push(item)
    },
    // 查看具体的客户
    lookCustomerHandler(params) {
      if (!params || (!params.quotationObject && params.quotationObject !== 0)) {
        this.$message.warning('请选择报价对象。')
        return
      }
      this.addCustomerPriceDialog.priceLevel = params.quotationObject
      this.addCustomerPriceDialog.accountId = 0
      this.addCustomerPriceDialog.visible = true
      this.searchCustomerPriceHandler()
    },
    // 查询客户
    searchCustomerPriceHandler() {
      this.loading = getLoading4Cxt()
      const item = { anyInteger: this.addCustomerPriceDialog.priceLevel }
      if (this.addCustomerPriceDialog.accountId > 0) {
        item.anyInteger1 = this.addCustomerPriceDialog.accountId
      }
      searchCustomerPrice(item).then(res => {
        this.addCustomerPriceDialog.rowData = res.data || []
      }).finally(() => {
        this.loading.close()
      })
    },
    // 删除客户价
    deleteCustomerPrice() {
      const chooseRows = this.khjBjdx.gridApi.getSelectedRows()
      if (chooseRows.length <= 0) {
        this.$message.warning('请选择要删除的客户价。')
        return
      }
      if (this.khjBjdx.rowData.length <= chooseRows.length) {
        this.$message.warning('客户价不能全部删除，最少留1个。')
        return
      }
      for (const item of chooseRows) {
        item.deleted = true
        item.quotationUuid = ''
        // 删除数据库
        if (item.uuid && !this.deleteCustomerPriceUuids.includes(item.uuid)) {
          this.deleteCustomerPriceUuids.push(item.uuid)
        }
        // 删除列表
        for (const obj of this.khjBjdx.rowData) {
          if ((item.tmpUuid && obj.tmpUuid === item.tmpUuid) || (item.uuid && obj.uuid === item.uuid)) {
            const index = this.khjBjdx.rowData.indexOf(item)
            if (index !== -1) {
              this.khjBjdx.rowData.splice(index, 1)
            }
          }
        }
      }
      this.$logger.log('deleteCustomerPriceUuids=====', this.form.customerPriceList)
      this.khjBjdx.gridApi.refreshCells({ force: true }) // 刷新
    },
    // 切换报价对象
    getKhjBjdxSelectedRow(event) {
      if (!event.data) return
      this.khjBjdxSelected = event.data
      this.khjBjdxFqSelected = null
      if (this.khjFq.gridApi) this.khjFq.gridApi.clearFocusedCell()
      if (this.khjJt.gridApi) this.khjJt.gridApi.clearFocusedCell()
    },
    // 选择分区
    getKhjBjdxFqSelectedRow(event) {
      if (!event.data) return
      this.khjBjdxFqSelected = event.data
    },
    // 梯度设置-金额列编辑
    onTdszAmountCellChange(params) {
      const field = params.colDef.field
      const curItem = params.data
      curItem.updated = true
      if (field === 'amount') {
        if (Number(curItem[field]) <= 0) {
          curItem[field] = 0.01
        }
      }
      if (this.khjBjdxFqSelected.tdRowData && this.khjBjdxFqSelected.tdRowData.length > 0) {
        for (const curTd of this.khjBjdxFqSelected.tdRowData) {
          if ((curItem.tmpUuid && curTd.tmpUuid === curItem.tmpUuid) || (curItem.uuid && curTd.uuid === curItem.uuid)) {
            curTd.amount = curItem.amount
            curTd.updated = true
          }
        }
      }
      this.khjJt.gridApi.refreshCells({ force: true }) // 刷新
    },
    // ==========================附加费 ====================
    // 添加附加费
    addCharge() {
      const charge = new FbaCharge().fillDefaultValue().getData()
      charge.tmpUuid = UIDUtil.createUID()
      const chargeScene = new FbaChargeScene().fillDefaultValue().getData()
      chargeScene.tmpUuid = UIDUtil.createUID()
      charge.chargeSceneList = [chargeScene]
      this.chargeDialog.charge = charge
      this.chargeDialog.action = 'add' // 新增
      this.chargeDialog.visible = true
    },
    // 切换报价对象
    getFjfSelectedRow(event) {
      if (!event.data) {
        return false
      }
      this.fjfSelectedRow = event.data
      return true
    },
    // 双击进详情
    onFjfRowDoubleClicked(event) {
      if (!this.getFjfSelectedRow(event)) return
      this.lookCharge()
    },
    // 查看附加费
    lookCharge(action) {
      this.chargeDialog.charge = this.fjfSelectedRow
      this.chargeDialog.action = action ? 'edit' : 'look'
      this.chargeDialog.visible = true
    },
    // 添加增收场景
    addChargeScene() {
      if (this.chargeDialog.charge.chargeSceneList && this.chargeDialog.charge.chargeSceneList.length === 10) {
        this.$message.warning('增收场景最多可添加10个。')
        return
      }
      const chargeScene = new FbaChargeScene().fillDefaultValue().getData()
      chargeScene.tmpUuid = UIDUtil.createUID()
      chargeScene.chargeUuid = this.chargeDialog.charge.uuid
      if (!this.chargeDialog.charge.chargeSceneList) this.chargeDialog.charge.chargeSceneList = []
      this.chargeDialog.charge.chargeSceneList.push(chargeScene)
    },
    // 删除增收场景
    deleteChargeScene(item) {
      if (!item) return
      for (const obj of this.chargeDialog.charge.chargeSceneList) {
        if ((item.tmpUuid && obj.tmpUuid === item.tmpUuid) || (item.uuid && obj.uuid === item.uuid)) {
          const index = this.chargeDialog.charge.chargeSceneList.indexOf(item)
          if (index !== -1) {
            this.chargeDialog.charge.chargeSceneList.splice(index, 1)
          }
        }
        if (item.uuid && !this.deleteChargeSceneUuids.includes(item.uuid)) {
          this.deleteChargeSceneUuids.push(item.uuid)
        }
      }
    },
    // 增收场景-计算公式输入值限制
    chargeSceneParamLimit(item, p, field) {
      console.log(111111)
      console.log(item)
      console.log(p)
      console.log(field)
      const curValue = item[field] = p
      const typeCodes = Array.from(FbaJobConstants.COMPARISON_TYPES, p => p.code)
      if (!StrUtils.isEmpty(curValue)) {
        if (isNaN(curValue) && !typeCodes.includes(curValue)) {
          this.$message.warning('请输入数值或选择参数。')
          setTimeout(() => {
            item[field] = ''
          }, 10)
          return
        }
        if (typeCodes.includes(curValue)) {
          item[field] = curValue
          return
        }
        if (!isNaN(curValue)) {
          item[field] = this.$numeral(curValue).format('0.00')
          return
        }
      }
    },
    // 编辑附加费
    editCharge() {
      this.lookCharge('edit')
    },
    // 附加费弹框确认
    confirmCharge() {
      if (!this.chargeDialog.charge.chargeItemId) {
        this.$message.warning('附加费名称不能为空。')
        return
      }
      if (!this.chargeDialog.charge.chargeType && this.chargeDialog.charge.chargeType !== 0) {
        this.$message.warning('附加费类型不能为空。')
        return
      }
      if (!this.chargeDialog.charge.currency) {
        this.$message.warning('币别不能为空。')
        return
      }
      this.chargeDialog.charge.updated = this.chargeDialog.action === 'edit'
      if (this.chargeDialog.action === 'edit') {
        this.fjf.gridApi.setRowData(this.form.chargeList)
      }
      if (this.chargeDialog.action === 'add') this.form.chargeList.push(this.chargeDialog.charge)
      this.chargeDialog.visible = false
    },
    // 删除附加费
    deleteCharge() {
      const chooseRows = this.fjf.gridApi.getSelectedRows()
      if (chooseRows.length <= 0) {
        this.$message.warning('请选择要删除的附加费。')
        return
      }
      for (const item of chooseRows) {
        item.deleted = true
        item.quotationUuid = ''
        // 删除数据库
        if (item.uuid && !this.deleteChargeUuids.includes(item.uuid)) {
          this.deleteChargeUuids.push(item.uuid)
        }
        // 删除列表
        for (const obj of this.fjf.rowData) {
          if ((item.tmpUuid && obj.tmpUuid === item.tmpUuid) || (item.uuid && obj.uuid === item.uuid)) {
            const index = this.fjf.rowData.indexOf(item)
            if (index !== -1) {
              this.fjf.rowData.splice(index, 1)
            }
          }
        }
        if (item.chargeSceneList && item.chargeSceneList.length > 0) {
          for (const chargeScene of item.chargeSceneList) {
            if (chargeScene.uuid && !this.deleteChargeSceneUuids.includes(chargeScene.uuid)) {
              this.deleteChargeSceneUuids.push(chargeScene.uuid)
            }
          }
        }
      }
      this.$logger.log('deleteChargeUuids=====', this.form.chargeList)
      this.fjf.gridApi.refreshCells({ force: true }) // 刷新
    },
    // 下一步-显示分区梯度
    onNextStepOne() {
      if (!this.form.serviceChannel) {
        this.$message.warning('渠道名称不能为空。')
        return
      }
      if ((!this.form.beginDate || !this.form.endDate) && !this.form.active) {
        this.$message.warning('报价有效期不能为空。')
        return
      }
      this.showNextOne = true
      this.showNextTwo = false

      // 如果没有分区，则默认加一个分区
      if (!this.form.partitionSettingList || this.form.partitionSettingList.length <= 0) {
        this.addPartitionSetting()
      }

      // 如果没有梯度，则默认加一个梯度
      if (!this.form.setupSettingList || this.form.setupSettingList.length <= 0) {
        this.addSetupSetting()
      }
    },
    // 下一步-显示客户价
    onNextStepTwo() {
      // 分区
      if (!this.form.partitionSettingList || this.form.partitionSettingList.length <= 0) {
        this.$message.warning('至少设置一个分区。')
        return
      }
      if (this.form.partitionSettingList && this.form.partitionSettingList.length > 0) {
        for (const partitionSetting of this.form.partitionSettingList) {
          if (!partitionSetting.pod) {
            this.$message.warning(partitionSetting.partitionName + '至少设置一个目的地。')
            return
          }
          if (!partitionSetting.referenceTiming) {
            this.$message.warning(partitionSetting.partitionName + '参考时效不能为空。')
            return
          }
        }
      }
      // 阶梯
      if (!this.form.setupSettingList || this.form.setupSettingList.length <= 0) {
        this.$message.warning('至少设置一个重量区间。')
        return
      }
      if (this.form.setupSettingList && this.form.setupSettingList.length > 0) {
        for (const setupSetting of this.form.setupSettingList) {
          if (!setupSetting.minWeight || Number(setupSetting.minWeight) === 0) {
            const minWeightMsg = this.form.chargePartType ? '体积下限' : '重量下限'
            this.$message.warning(minWeightMsg + '不能为空。')
            return false
          }
          if (!setupSetting.maxWeight || Number(setupSetting.maxWeight) === 0) {
            const maxWeightMsg = this.form.chargePartType ? '体积上限' : '重量上限'
            this.$message.warning(maxWeightMsg + '不能为空。')
            return false
          }
          if (!setupSetting.calcAccuracy || Number(setupSetting.calcAccuracy) === 0) {
            this.$message.warning('计算精度不能为空。')
            return false
          }
        }
      }
      this.showNextTwo = true
      this.showNextThree = false

      // 如果没有客户价，则默认配置一个客户价
      if (!this.form.customerPriceList || this.form.customerPriceList.length <= 0) {
        this.addCustomerPrice()
      }
    },
    // 下一步-显示附加费
    onNextStepThree() {
      if (!this.form.customerPriceList || this.form.customerPriceList.length <= 0) {
        this.$message.warning('至少配置一个客户价。')
        return
      }
      for (const customerPrice of this.form.customerPriceList) {
        if (!customerPrice.quotationObject && customerPrice.quotationObject !== 0) {
          this.$message.warning('报价对象不能为空。')
          return
        }
      }
      this.showNextThree = true
    }
  }
}
</script>
<style lang="scss" scoped>
.quotation-detail {
  .el-collapse {
    &-item {
      &__header {
        padding: 0 15px;
        border-bottom: none;
        color: #4283ff;
        font-weight: bold;
        background-color: #fff;
      }
      &__wrap {
        padding: 15px;
        border-bottom: none;
        background-color: #f0f3f8!important;
      }
      &__arrow {
        color: #303133;
      }
    }
  }
}
.quotationLabel::v-deep {
  .el-form-item__content {
    .el-color-picker--mini .el-color-picker__trigger {
      width: 220px !important;
    }
    .el-color-picker--mini .el-color-picker__mask {
      width: 0px !important;
    }
  }
}

</style>
